import { useQuery } from 'react-query';
import { QUERY_KEYS } from '../../../../api/query-keys';
import { availabilityService } from '../../../../api/services';
import { useSiteDetection } from '../../../hooks';
import { CACHE_TIME_LONG } from '../../../react-query/query-defaults';
import { CompanyFlexpools } from '../../../../api/services/availability/availability-service.schema';

export const useGetCompanyFlexpools = (companyId?: string) => {
  const { site } = useSiteDetection();
  const queryFn = async () => await availabilityService.getCompanyFlexpools(site, companyId);

  return useQuery<CompanyFlexpools>(QUERY_KEYS.flexpoolFilters(companyId), queryFn, {
    cacheTime: CACHE_TIME_LONG,
    enabled: !!companyId || site === 'ogp',
  });
};
